import {
	Component,
	OnDestroy,
	OnInit,
} from '@angular/core';
import { Subject, Subscription } from 'rxjs';
import { UnderwritingService } from '@lmc-app/core/services/underwriting.service';

@Component({
	selector: 'app-uw-daily-stat',
	templateUrl: './uw-daily-stat.component.html',
	styleUrls: ['./uw-daily-stat.component.scss'],
})
export class UwDailyStatComponent implements OnInit, OnDestroy {
	private parentSub = new Subscription();
	private readonly _onDestroy = new Subject<void>();
	protected uws = [];
	protected uwTotal: any;
	protected today = new Date().toISOString().split('T')[0];

	constructor(
		private underwritingService: UnderwritingService,
	) { }

	public ngOnInit(): void {
		this.getUWPerformanceReport();
	}

	public ngOnDestroy(): void {
		this.parentSub.unsubscribe();
		this._onDestroy.next();
		this._onDestroy.complete();
	}

	protected formatSeconds(totalSeconds: number) {
		const hours = Math.floor(totalSeconds / 3600);
		const minutes = Math.floor((totalSeconds % 3600) / 60);
		const seconds = totalSeconds % 60;

		// Enforce two-digit formatting using padStart
		const hh = String(hours).padStart(2, '0');
		const mm = String(minutes).padStart(2, '0');
		const ss = String(seconds).padStart(2, '0');

		return `${hh}:${mm}:${ss}`;
	}

	private getUWPerformanceReport() {
		this.parentSub.add(this.underwritingService
			.getDailyStat(this.today)
			.subscribe((res: any) => {
				const uwDailyStats = res;
				this.uws = uwDailyStats
					.map((uw: { totalTalkSecond: number, avgTalkSecond: number }, index: number) => ({
						rank: index + 1,
						...uw,
						totalTalkTime: this.formatSeconds(uw.totalTalkSecond),
						avgTalkTime: this.formatSeconds(uw.avgTalkSecond),
					}));
				this.uwTotal = {
					loanInterviewCount: uwDailyStats.map((uw: { loanInterviewCount: number }) => uw.loanInterviewCount).reduce((acc: number, val: number) => acc + val, 0),
					approved: uwDailyStats.map((uw: { approved: number }) => uw.approved).reduce((acc: number, val: number) => acc + val, 0),
					declined: uwDailyStats.map((uw: { declined: number }) => uw.declined).reduce((acc: number, val: number) => acc + val, 0),
					fileReview: uwDailyStats.map((uw: { fileReview: number }) => uw.fileReview).reduce((acc: number, val: number) => acc + val, 0),
					checklist: uwDailyStats.map((uw: { checklist: number }) => uw.checklist).reduce((acc: number, val: number) => acc + val, 0),
					call: uwDailyStats.map((uw: { call: number }) => uw.call).reduce((acc: number, val: number) => acc + val, 0),
					totalTalkTime: this.formatSeconds(uwDailyStats.map((uw: { totalTalkSecond: number }) => uw.totalTalkSecond).reduce((acc: number, val: number) => acc + val, 0)),
					avgTalkTime: this.formatSeconds(uwDailyStats.map((uw: { avgTalkSecond: number }) => uw.avgTalkSecond).reduce((acc: number, val: number) => acc + val, 0)),
				};
			}));
	}
}
